<template>
  <div>
    <Loader />
    <section class="sign-in-page">
      <div id="container-inside">
        <div class="cube"></div>
        <div class="cube"></div>
        <div class="cube"></div>
        <div class="cube"></div>
        <div class="cube"></div>
      </div>
      <b-container class="p-0">
        <b-row class="no-gutters height-self-center">
          <b-col sm="12" class="align-self-center bg-primary rounded">
            <b-row class="m-0">
              <b-col md="5" class="bg-white sign-in-page-data">
                <div class="sign-in-from">
                  <a class="sign-in-logo fullHeight mb-5" href="#">
                    <img :src="logo" class="img-fluid" alt="logo" />
                  </a>

                  <router-view></router-view>
                </div>
              </b-col>
              <b-col md="7" class="text-left sign-in-page-image">
                <div class="sign-in-detail text-white mr-5">
                  <a class="sign-in-logo right-logo mb-3" href="#">
                    <img :src="logoRight" class="img-fluid" alt="logo" />
                  </a>
                  <h3 class="text-white">Welcome to Our Partner Portal</h3>
                  <p class="fs-1000">
                    For over 15 years we have been providing dealerships and
                    partners with a point of sale novated leasing portal. The
                    portal delivers instant quotes, online applications,
                    approvals and settlements, generating valuable additional
                    income.
                    <i
                      ><u
                        >With our portal you can capture and convert all Novated
                        Leasing enquiry.</u
                      ></i
                    >
                  </p>
                  <p class="fs-1000">
                    We provide full training, marketing and support.
                  </p>
                  <p class="fs-1000">
                    To take advantage of this income stream click on the button
                    below and we can have you up and running within the day.
                  </p>
                  <Slick :option="slickOptions">
                    <div class="item">
                      <router-link
                        to="/sign-up"
                        class="btn btn-danger float-center float-center"
                        >Register Now</router-link
                      >
                    </div>
                  </Slick>

                  <div class="row mt-5">
                    <div class="col-lg-4 col-md-4 col-12 text-center">
                      <appModalPrivacyPolicy></appModalPrivacyPolicy>
                    </div>
                    <div class="col-lg-4 col-md-4 col-12 text-center">
                      <appModalTermsOfUse></appModalTermsOfUse>
                    </div>
                    <div class="col-lg-4 col-md-4 col-12 text-center">
                      <router-link
                        to="/sign-up"
                        class="float-center float-center text-white fw-300"
                        >Contact Us</router-link
                      >
                    </div>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
    </section>
  </div>
</template>
<script>
import Loader from '../../components/findash/loader/Loader'
import logo from '../../assets/images/vehicle-solutions-logo-type2-1.png'
import logoRight from '../../assets/images/vsa/vsa_full_white.logo.png'
import { findash } from '../../config/pluginInit'
import bgImage from '../../assets/images/login/login-2.jpg'
import appModalPrivacyPolicy from '../../components/comm/ModalPrivacyPolicy.vue'
import appModalTermsOfUse from '../../components/comm/ModalTermsOfUse.vue'
export default {
  name: 'AuthLayout1',
  components: {
    Loader,
    appModalPrivacyPolicy,
    appModalTermsOfUse
  },
  mounted() {
    findash.index()
  },
  data() {
    return {
      slickOptions: {
        slidesToShow: 1,
        arrows: false
      },
      logo: logo,
      logoRight: logoRight,
      bgImageURL: bgImage
    }
  }
}
</script>

</style>
